import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Card, CardActions, CardContent, Table, TablePagination } from '@mui/material';
import type { ConnectionSearchItem } from 'app/types';
import type { ConnectionsTableSort } from './useConnectionsTable';
import { useConnectionsTable } from './useConnectionsTable';
import { ConnectionsTableHeader } from './ConnectionsTableHeader';
import { ConnectionsTableBody } from './ConnectionsTableBody';
import { ConnectionsTableLoading } from './ConnectionsTableLoading';

type ConnectionsTableProps = {
  className?: string;
  connections: ConnectionSearchItem[];
  page: number;
  rowsPerPage: number;
  totalCount: number;
  loading: boolean;
  onPageChange: (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => void;
  onRowsPerPageChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onSortChange?: (sort: ConnectionsTableSort) => void;
};

export const ConnectionsTable = ({
  className,
  connections,
  page,
  rowsPerPage,
  totalCount,
  loading,
  onPageChange,
  onRowsPerPageChange,
  onSortChange,
}: ConnectionsTableProps) => {
  const { sortState, handleSortChange } = useConnectionsTable({ onSortChange });

  return (
    <Card className={className}>
      <CardContent sx={{ padding: 0 }}>
        <PerfectScrollbar>
          <Box sx={{ minWidth: 1050 }}>
            <Table>
              <ConnectionsTableHeader sortState={sortState} onSortChange={handleSortChange} />
              {loading ? (
                <ConnectionsTableLoading rowsPerPage={rowsPerPage} />
              ) : (
                <ConnectionsTableBody connections={connections} />
              )}
            </Table>
          </Box>
        </PerfectScrollbar>
      </CardContent>
      <CardActions sx={{ justifyContent: 'flex-end' }}>
        <TablePagination
          component="div"
          count={totalCount}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
        />
      </CardActions>
    </Card>
  );
};

export default ConnectionsTable;
